import { Core } from "@/core/Core";

export default {

  async getTaxGroups() {
    try {
      return await Core.request("GET", `/api/tax_groups`);
    } catch (e) {
      return null;
    }
  },

  async getTaxGroup(context, {taxGroupId}) {
    try {
      return await Core.request("GET", `/api/tax_groups/${taxGroupId}`);
    } catch (e) {
      return null;
    }
  },
  
  async saveTaxGroup(context, {data}) {
    try {
      let id = data.id;
      return id
        ? await Core.request('PUT',  `/api/tax_groups/${id}`, data)
        : await Core.request('POST', `/api/tax_groups`, data);
    } catch (e) {
      return null;
    }
  },
  
  async getTaxes() {
    try {
      return await Core.request("GET", `/api/taxes`);
    } catch (e) {
      return null;
    }
  },

  async deleteTax(context, {taxId}) {
    try {
      return await Core.request("DELETE", `/api/taxes/${taxId}`);
    } catch (e) {
      return null;
    }
  }
}